import { Switch, Route, Redirect } from 'react-router-dom';
import { useAuth } from '../contexts/auth-context';
import AdminLayout from '../common/Layouts/AdminLayout';
import asyncComponent from './../AsyncComponent';
import LoginForm from '../views/login/LoginForm';

const driverContainer = asyncComponent(() =>
  import('../views/driver-management/DriverManagementContainer').then(
    (module) => module.default
  )
);

const driverDetailContainer = asyncComponent(() =>
  import('../views/driver-details/DriverDetailsContainer').then(
    (module) => module.default
  )
);

const storeManagementContainer = asyncComponent(() =>
  import('../views/store-management/StoreManagementContainer').then(
    (module) => module.default
  )
);

const inventoryManagementContainer = asyncComponent(() =>
  import('../views/inventory-management/InventoryManagementContainer').then(
    (module) => module.default
  )
);

const inventoryDetailsContainer = asyncComponent(() =>
  import('../views/inventory-details/InventoryDetailsContainer').then(
    (module) => module.default
  )
);

const storeDetailsContainer = asyncComponent(() =>
  import('../views/store-details/StoreDetailsContainer').then(
    (module) => module.default
  )
);

const bulkUploadV2Container = asyncComponent(() =>
  import('../views/bulkuploadv2/BulkFileContainer').then(
    (module) => module.default
  )
);

const bulkUploadV2Details = asyncComponent(() =>
  import('../views/bulkuploadv2/BulkUploadStatusDetailsContainer').then(
    (module) => module.default
  )
);

const configsContainer = asyncComponent(() =>
  import('../views/config-management/ConfigTiles').then(
    (module) => module.default
  )
);

const c2bslotsConfigContainer = asyncComponent(() =>
  import('../views/config-management/c2b-slots').then(
    (module) => module.default
  )
);

const c2bslotsConfigDetailsContainer = asyncComponent(() =>
  import('../views/config-management/c2b-slots/detail').then(
    (module) => module.default
  )
);

const unAuthComp = asyncComponent(() =>
  import('../views/account/UnAuthAccessComponent').then(
    (module) => module.default
  )
);

const logisticManagementContainer = asyncComponent(() =>
  import('../views/logistic-management/logisticManagementContainer').then(
    (module) => module.default
  )
);

const documentPendencyContainer = asyncComponent(() =>
  import('../views/document-pendency/DocumentPendencyContainer').then(
    (module) => module.default
  )
);

const KeyManagementContainer = asyncComponent(() =>
  import('../views/key-management/KeyManagementContainer').then(
    (module) => module.default
  )
);

const enbdRstlScreen = asyncComponent(() =>
  import('../views/enbd-rstl/EnbdRstlScreen.jsx').then(
    (module) => module.default
  )
);

const enbdRstlDetailScreen = asyncComponent(() =>
  import('../views/enbd-rstl/EnbdRstlDetailScreen.jsx').then(
    (module) => module.default
  )
);

const bigDealerNetworkContainer = asyncComponent(() =>
  import('../views/big-dealer-network/BigDealerNetworkContainer.js').then(
    (module) => module.default
  )
);

const userManagementV2Container = asyncComponent(() =>
  import('../views/user-management-v2/UserManagementV2.js').then(
    (module) => module.default
  )
);

const userDetailsV2Container = asyncComponent(() =>
  import(
    '../views/user-management-v2/components/user-details/UserDetailsV2'
  ).then((module) => module.default)
);

const masterdataComponent = asyncComponent(() =>
  import('../views/masterdata-v2/MasterDataComponent.js').then(
    (module) => module.default
  )
);

const masterDataGridComponent = asyncComponent(() =>
  import('../views/masterdata-v2/MasterDataGrid.js').then(
    (module) => module.default
  )
);

const masterDataEntityDetailsComponent = asyncComponent(() =>
  import('../views/masterdata-v2/MasterDataEntityDetails.js').then(
    (module) => module.default
  )
);

const scheduledTasksComponent = asyncComponent(() =>
  import('../views/scheduled-tasks/ScheduledTasks.js').then(
    (module) => module.default
  )
);

const userPreferencesComponent = asyncComponent(() =>
  import('../views/user-preferences').then((module) => module.default)
);

const dndListComponent = asyncComponent(() =>
  import('../views/dnd').then((module) => module.default)
);

const fastagScreen = asyncComponent(() =>
  import('../views/fastag-screen/FastagScreen.jsx').then(
    (module) => module.default
  )
);

const fastagOrderScreen = asyncComponent(() =>
  import('../views/fastag-order-screen/FastagOrderScreen.jsx').then(
    (module) => module.default
  )
);

const carCleaningQa = asyncComponent(() =>
  import('../views/car-cleaning/car-cleaning-qa/CarCleaningQa.jsx').then(
    (module) => module.default
  )
);

const carCleaningHistory = asyncComponent(() =>
  import(
    '../views/car-cleaning/car-cleaning-history/CarCleaningHistory.jsx'
  ).then((module) => module.default)
);

const carCleaningQaDetail = asyncComponent(() =>
  import(
    '../views/car-cleaning/car-cleaning-qa-detail/CarCleaningQaDetail.jsx'
  ).then((module) => module.default)
);

const carCleaningHistoryDetail = asyncComponent(() =>
  import(
    '../views/car-cleaning/car-cleaning-history-detail/CarCleaningHistoryDetail.jsx'
  ).then((module) => module.default)
);

const trainingTutorials = asyncComponent(() =>
  import('../views/car-cleaning/training-tutorials/TrainingTutorials.jsx').then(
    (module) => module.default
  )
);

const couponRequests = asyncComponent(() =>
  import('../views/coupon-requests/CouponRequests.js').then(
    (module) => module.default
  )
);

const couponConfigManagement = asyncComponent(() =>
  import('../views/coupon-config-management/CouponConfigManagement.js').then(
    (module) => module.default
  )
);

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export const routeConfig = [
  {
    path: '/login',
    exact: true,
    component: LoginForm,
  },
  {
    path: '/unauthorized',
    exact: true,
    component: unAuthComp,
  },
  {
    path: '/inventory',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: inventoryManagementContainer,
  },
  {
    path: '/inventory/:inventoryId',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: inventoryDetailsContainer,
  },
  {
    path: '/inventory/:inventoryId/qr-code',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: inventoryDetailsContainer,
  },
  {
    path: '/logistic',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: logisticManagementContainer,
  },
  {
    path: '/logistic/:inventoryId',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: inventoryDetailsContainer,
  },
  {
    path: '/driver',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: driverContainer,
  },
  {
    path: '/driver/add',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: driverDetailContainer,
  },
  {
    path: '/driver/:driverId',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: driverDetailContainer,
  },
  {
    path: '/ums',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: userManagementV2Container,
  },
  {
    path: '/ums/addUser',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: userDetailsV2Container,
  },
  {
    path: '/ums/:userId',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: userDetailsV2Container,
  },
  {
    path: '/user-preferences',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: userPreferencesComponent,
  },
  {
    path: '/user-preferences/dnd',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: dndListComponent,
  },
  {
    path: '/location',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: storeManagementContainer,
  },
  {
    path: '/location/addlocation',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: storeDetailsContainer,
  },
  {
    path: '/location/:locationId',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: storeDetailsContainer,
  },
  {
    path: '/masterdata',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: masterdataComponent,
  },
  {
    path: '/masterdata/:entity',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: masterDataGridComponent,
  },
  {
    path: '/masterdata/:entity/add',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: masterDataEntityDetailsComponent,
  },
  {
    path: '/masterdata/:entity/:entityId',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: masterDataEntityDetailsComponent,
  },
  {
    path: '/bulk-upload-v2',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: bulkUploadV2Container,
  },
  {
    path: '/bulk-upload-v2/:id',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: bulkUploadV2Details,
  },
  {
    path: '/configs',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: configsContainer,
  },
  {
    path: '/configs/c2b-slots',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: c2bslotsConfigContainer,
  },
  {
    path: '/configs/c2b-slots/edit/:code',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: c2bslotsConfigDetailsContainer,
  },
  {
    path: '/configs/c2b-slots/add',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: c2bslotsConfigDetailsContainer,
  },
  {
    path: '/document-pendency',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: documentPendencyContainer,
  },
  {
    path: '/key-management',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: KeyManagementContainer,
  },
  {
    path: '/enbd-rstl',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: enbdRstlScreen,
  },
  {
    path: '/enbd-rstl/:appointmentId',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: enbdRstlDetailScreen,
  },
  {
    path: '/big-dealer',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: bigDealerNetworkContainer,
  },
  {
    path: '/scheduled-tasks',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: scheduledTasksComponent,
  },
  {
    path: '/fastag',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: fastagScreen,
  },
  {
    path: '/fastag/:id',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: fastagOrderScreen,
  },
  {
    path: '/car-cleaning-qa',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: carCleaningQa,
  },
  {
    path: '/car-cleaning-history',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: carCleaningHistory,
  },
  {
    path: '/car-cleaning-qa/:id',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: carCleaningQaDetail,
  },
  {
    path: '/car-cleaning-history/:id',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: carCleaningHistoryDetail,
  },
  {
    path: '/training-tutorials',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: trainingTutorials,
  },
  {
    path: '/coupon-requests',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: couponRequests,
  },
  {
    path: '/coupon-config-management',
    exact: true,
    isSecure: true,
    withLayout: true,
    component: couponConfigManagement,
  },
];

function BifrostRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Switch>
      <Route exact path="/" component={LoginForm} />
      <Route exact path="/unauthorized" component={unAuthComp} />
      {routeConfig.map((route) => {
        if (route.path === '/' || route.path === '/unauthorized') {
          return null;
        }
        const RouteComponent = route.isSecure ? ProtectedRoute : Route;
        return (
          <RouteComponent
            {...route}
            key={route.path}
            component={
              route.withLayout ? AdminLayout(route.component) : route.component
            }
          />
        );
      })}
      <Route exact path="/">
        {isAuthenticated ? <Redirect to="/inventory" /> : <Redirect to="/" />}
      </Route>
      <Redirect to="/" />
    </Switch>
  );
}

export default BifrostRoutes;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
